import { IsEnum, IsNotEmpty, IsNumber, IsOptional } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { RmOccupancyEnum, RmRackPositionEnum, RmRackPositionTypeEnum } from '@gtpl/shared-models/masters';

export class RmRackDTONew {
    @ApiProperty()
    @IsNotEmpty({ message: "Plant Id should not be empty" })
    @IsNumber()
    plantId: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Rack Id should not be empty" })
    rmRackMasterId: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Rack Code should not be empty" })
    rmRackCode: string;

    @ApiProperty()
    @IsNotEmpty({ message: "Rack Position Code should not be empty" })
    rmRackPositionCode: string;

    @ApiProperty()
    @IsNotEmpty({ message: "Rack Reserve code should not be empty" })
    rmRackReserveCode: string;

    @ApiProperty({
        enum: RmRackPositionEnum,
        default: RmRackPositionEnum.BACK_CENTER
    })
    @IsNotEmpty({ message: "Rack Position should not be empty" })
    @IsEnum(RmRackPositionEnum)
    rmRackPosition: RmRackPositionEnum;

    @ApiProperty()
    @IsNotEmpty({ message: "Rack Level should not be empty" })
    @IsNumber()
    rmRackLevel: number;
    @ApiProperty()
    @IsNotEmpty({ message: "Rack Column should not be empty" })
    @IsNumber()
    rmRackColumn: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Rack Boundaries should not be empty" })
    rmRackBoundaries: string;

    @ApiProperty()
    @IsNotEmpty({ message: "Associate RFIS's should not be empty" })
    assocRfId: string;

    @ApiProperty({
        enum: RmOccupancyEnum,
        default: RmOccupancyEnum.NOT_OCCUPIED
    })
    @IsOptional()
    @IsEnum(RmOccupancyEnum)
    occupancy: RmOccupancyEnum;
    @ApiProperty({
        enum: RmRackPositionTypeEnum,
        default: RmRackPositionTypeEnum.REAR
    })
    @IsOptional()
    @IsEnum(RmRackPositionTypeEnum)
    rmRackPositionType: RmRackPositionTypeEnum;

    @ApiProperty()
    @IsOptional()
    createdUser: string;

    @ApiProperty()
    @IsOptional()
    updatedUser : string;

    @ApiProperty()
    @IsNotEmpty({ message: "Zone Id should not be empty" })
    zoneId: number;

    @ApiProperty()
    brandId?: number;

    @ApiProperty()
    itemSubCategoryId?: number;

    @ApiProperty()
    isReserved?: boolean;

    @ApiProperty()
    rmRackPositionId?:number;

}
